import {
    SEQUENCE_ROMAN,
    SEQUENCE_ARABIC,
    SEQUENCE_ARABIC_EVEN,
    SEQUENCE_ARABIC_ODD,
    SEQUENCE_ALPHABETIC,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import {
    arabicToLetter,
    arabicToRoman,
    arabicToArabicEven,
    arabicToArabicOdd
} from './convertArabic';

function getRepresentation(number, sequence) {
    if (sequence === SEQUENCE_ARABIC) {
        return number;
    }
    if (sequence === SEQUENCE_ARABIC_EVEN) {
        return arabicToArabicEven(number);
    }
    if (sequence === SEQUENCE_ARABIC_ODD) {
        return arabicToArabicOdd(number);
    }
    if (sequence === SEQUENCE_ALPHABETIC && number > 0) {
        return arabicToLetter(number);
    }
    if (sequence === SEQUENCE_ROMAN && number > 0) {
        return arabicToRoman(number);
    }

    return null;
}

function getNextFromSequence(start, sequence) {
    return getRepresentation(start + 1, sequence);
}

function getPreviousFromSequence(start, sequence) {
    return getRepresentation(start - 1, sequence);
}

export {
    getNextFromSequence,
    getPreviousFromSequence,
};
